<!-- 取消售后按钮 组件-->
<!-- afterId 必传-->
<template>
  <div>
    <van-button
      plain color="#999999"
      class="div-btn"
      round
      size="mini"
      :loading="cancelFunLoading"
      @click="cancelOutMoneyFun"
    >{{radio2Format[afterSaleType] || '取消售后'}}</van-button>
  </div>
</template>
<script>
import http from "@/utils/axios";
import { Toast, Dialog } from "vant";
export default {
  props: {
    afterId: {
      default: "",
      required: true
    },
    subId: {
      type: Number,
      default: 0, 
      required: true
    },
    afterSaleType: {
      type: String,
      default: '',
      required: true
    },
  },
  data() {
    return {
      cancelFunLoading: false,
      radio2Format:{
        'JUST_PRODUCT': '取消售后',
        'JUST_MONEY': '取消售后',
        'CHANGE_PRODUCT': '取消换货',
        'WAIT_RECEIVE_JUST_MONEY':'取消售后'
      },
    };
  },
  methods: {
    cancelOutMoneyFun() {
      this.cancelFunLoading = true;
      let params = {
        afterSaleType: this.afterSaleType,
        afterid: this.afterId,
        checkPrice: 0,
        status: "",
        subOrderId: this.subOrderId
      };
      let message = ''
      if (this.afterSaleType == 'CHANGE_PRODUCT' || this.afterSaleType == 'JUST_PRODUCT') {
        if (this.afterSaleType == 'CHANGE_PRODUCT') {
          message = '您确认取消本次售后？超出保障期后将无法再次发起售后'
        } else {
          message = '您确认取消本次售后？超出保障期后将无法再次发起售后'
        }
      } else {
        message = '确认要取消退款申请吗？'
      }
      this.$dialog
        .confirm({
          title: "温馨提示",
          confirmButtonColor:"#F8A651",
          message
        })
        .then(() => {
          http({
            url: "order/app/newafter/cancelApply",
            method: "POST",
            parmes: params
          }).then(rps => {
            if (rps.code === 200) {
              this.cancelFunLoading = false;
              Toast(
                rps.message || "取消退款已提交成功,请您耐心等待平台审核结果"
              );
              this.showPay = false;
              this.$emit("callbackFun");
            } else {
              this.cancelFunLoading = false;
              Toast(rps.message || "取消退款提交失败");
            }
          });
        })
        .catch(() => {
          this.cancelFunLoading = false;
        });
    }
  },
  created() {},
  components: {}
};
</script>
<style lang="less" scoped>
.div-btn {
  color: #999;
  width: 160px;
  height: 0.8rem;
  text-align: center;
  font-size: 24px;
}

.yel {
  background: #f8d541;
}
</style>